import { IBundleItem } from "@/api/AppApi/services/product/interfaces/product-bundle-types";
import { Link } from "@/app/components/lib/navigation/Link";
import NextImage from "@/app/components/lib/NextImage";
import Price from "@/app/components/lib/Price";
import Attributes from "../../details-belpers/product-attributes/Attributes";
import { IProductMinimizedData } from "../../details-belpers/product-attributes/helpers/interfaces";

export default function BundleItem({
  product,
  quantity,
  setSelectedChildIndex,
  selectedChildId,
  WithoutBorder,
}: IBundleItem & {
  setSelectedChildIndex: (index: number | null) => void;
  selectedChildId?: number | null;
  WithoutBorder?: boolean;
}) {
  const img = !!selectedChildId
    ? product.children.find((child) => child.id === selectedChildId)
        ?.thumbnail_url
    : product?.thumbnail_url;
  return (
    <div
      className="product-bundle"
      style={WithoutBorder ? { border: "none" } : undefined}
    >
      <div className="product-bundle-image">
        <Link
          skipCheckingForLang
          prefetch={false}
          href={`/products/${product.slug}`}
        >
          <NextImage
            src={img ?? product?.thumbnail_url}
            alt={product?.name}
            width={96}
            height={96}
            className="image"
          />
        </Link>
      </div>
      <div className="product-bundle-info">
        <Link
          skipCheckingForLang
          prefetch={false}
          href={`/products/${product.slug}`}
          className="product-bundle-title m-0"
        >
          <h4 className="product-bundle-title m-0">{`${product?.name} (X${quantity})`}</h4>
        </Link>
        <Price
          price={{ value: product.price, className: "product-bundle-price " }}
        />
        {product.attributes_builder?.length > 0 && (
          <Attributes
            product={product as IProductMinimizedData}
            autoSelectFirstChild={false}
            setSelectedChildIndex={setSelectedChildIndex}
          />
        )}
      </div>
    </div>
  );
}
